import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "order-progress"
};
const _hoisted_2 = {
  class: "main-wrap"
};
const _hoisted_3 = {
  class: "header-bar"
};
const _hoisted_4 = {
  class: "driver-status"
};
const _hoisted_5 = {
  key: 0,
  class: "distance-you"
};
const _hoisted_6 = {
  key: 1,
  class: "distance-you"
};
const _hoisted_7 = {
  key: 2,
  class: "await-you"
};
const _hoisted_8 = {
  key: 3,
  class: "distance-you"
};
const _hoisted_9 = {
  key: 4,
  class: "distance-you"
};
const _hoisted_10 = {
  key: 5,
  class: "distance-you"
};
const _hoisted_11 = {
  key: 6,
  class: "distance-you"
};
const _hoisted_12 = {
  class: "mapContainer"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1);
const _hoisted_14 = {
  class: "map-button"
};
const _hoisted_15 = {
  key: 0,
  class: "button left-button"
};
const _hoisted_16 = {
  class: "bottom-wrap progress-wrap"
};
const _hoisted_17 = {
  class: "bottom-main"
};
const _hoisted_18 = {
  class: "card-bold card-bg order-status"
};
const _hoisted_19 = {
  class: "status-layout"
};
const _hoisted_20 = {
  class: "status"
};
const _hoisted_21 = {
  class: "remind"
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", null, "如需变更行程，请与司机协商", -1);
const _hoisted_23 = /*#__PURE__*/_createElementVNode("strong", null, "保持电话畅通", -1);
const _hoisted_24 = {
  class: "order-flag"
};
const _hoisted_25 = {
  class: "vehicle-data"
};
const _hoisted_26 = {
  class: "plate-number"
};
const _hoisted_27 = {
  key: 0,
  class: "vehicle-attr"
};
const _hoisted_28 = {
  class: "driver-info"
};
const _hoisted_29 = {
  class: "name"
};
const _hoisted_30 = {
  key: 0,
  class: "star-rating"
};
const _hoisted_31 = {
  key: 1,
  class: "order-count"
};
const _hoisted_32 = {
  class: "vehicle-thumbnail"
};
const _hoisted_33 = ["src"];
const _hoisted_34 = ["src"];
const _hoisted_35 = {
  key: 2,
  class: "operate"
};
const _hoisted_36 = {
  key: 0,
  class: "route-info arrive"
};
const _hoisted_37 = {
  class: "left"
};
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
}, null, -1);
const _hoisted_39 = {
  class: "address"
};
const _hoisted_40 = {
  class: "right"
};
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
}, null, -1);
const _hoisted_42 = {
  class: "address"
};
const _hoisted_43 = {
  key: 1,
  class: "card order-mileage"
};
const _hoisted_44 = {
  class: "amount"
};
const _hoisted_45 = {
  class: "amount"
};
const _hoisted_46 = {
  class: "amount"
};
const _hoisted_47 = {
  class: "amount"
};
const _hoisted_48 = {
  class: "amount"
};
const _hoisted_49 = {
  class: "card call-options"
};
const _hoisted_50 = {
  key: 1,
  class: "options-item"
};
const _hoisted_51 = {
  key: 2,
  class: "separate"
};
const _hoisted_52 = {
  key: 4,
  class: "options-item"
};
const _hoisted_53 = {
  key: 5,
  class: "options-item"
};
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "12px"
  }
}, "行程计算中...", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _$setup$orderDetailDa, _$setup$orderDetailDa2;
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_loading = _resolveComponent("van-loading");
  const _directive_height_animate = _resolveDirective("height-animate");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "button back-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args))
  }, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    color: "#333"
  })]), _createElementVNode("div", _hoisted_4, [$setup.orderDetailData && ($setup.orderDetailData.order_type === 'ORDER_TYPE_REALTIME' || $setup.orderDetailData.order_type === 'ORDER_TYPE_VOICE') && $setup.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 司机正在准备接驾 ")) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_WAITING' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(" 司机距您 "), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatFloat($setup.kilometer)), 1), _createTextVNode(" 公里，大约需要 "), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatSeconds($setup.drivingTime)), 1)])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_PICK_UP' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createTextVNode(" 司机已等待"), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatSeconds($setup.awaitSecond, true)), 1)])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type !== 'ORDER_TYPE_VOICE' && $setup.orderDetailData.order_state === 'ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createTextVNode(" 预计行驶 "), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatFloat($setup.kilometer)), 1), _createTextVNode(" 公里，大约需要 "), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatSeconds($setup.drivingTime)), 1)])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_VOICE' && $setup.orderDetailData.order_state === 'ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 正在前往目的地 ")) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' || $setup.orderDetailData.order_state === 'ORDER_STATUS_RATING') ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createTextVNode(" 目的地已到达，实际行驶 "), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatSeconds($options.CommonUtil.toDate($setup.orderDetailData.arrive_destination_time, 'YYYY-MM-DD HH:mm:ss').getTime() / 1000 - $options.CommonUtil.toDate($setup.orderDetailData.departure_destination_time, 'YYYY-MM-DD HH:mm:ss').getTime() / 1000)), 1)])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_RESERVATION' && $setup.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createTextVNode(" 即将在 "), _createElementVNode("strong", null, _toDisplayString($setup.orderDetailData.useCarTime), 1), _createTextVNode(" 出发 ")])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [false ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_van_icon, {
    class: "security",
    name: require('@/assets/icon/security.svg')
  }, null, 8, ["name"])])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "button right-button",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.getCurrentPosition && $options.getCurrentPosition(...args))
  }, [_createVNode(_component_van_icon, {
    name: require('@/assets/icon/map/aim.svg')
  }, null, 8, ["name"])])) : _createCommentVNode("", true)])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [$setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_RESERVATION' ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 0,
    size: "large",
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(" 预约 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.service_car_type === 'ORDER_CAR_TYPE_ONLINE_TAXI' ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 1,
    size: "large",
    type: "danger"
  }, {
    default: _withCtx(() => [_createTextVNode(" 新出租 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.service_car_type === 'ORDER_CAR_TYPE_NORMAL_TAXI' ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 2,
    color: "#ff9500",
    size: "large",
    type: "warning"
  }, {
    default: _withCtx(() => [_createTextVNode(" 出租车 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_type === 'ORDER_TYPE_REALTIME' || $setup.orderDetailData.order_type === 'ORDER_TYPE_VOICE') && $setup.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createTextVNode(" 已为您找到附近的司机 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_WAITING' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [_createTextVNode(" 司机正在接驾路上 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_PICK_UP' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 5
  }, [_createTextVNode(" 司机已经到达上车地点 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 6
  }, [_createTextVNode(" 正在前往目的地 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' || $setup.orderDetailData.order_state === 'ORDER_STATUS_RATING') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 7
  }, [_createTextVNode(" 已安全到达目的地 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_RESERVATION' && $setup.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 8
  }, [_createTextVNode(" 您的预约已匹配到司机 ")], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [$setup.orderDetailData && ($setup.orderDetailData.order_type === 'ORDER_TYPE_REALTIME' && ($setup.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAITING') || $setup.orderDetailData.order_type === 'ORDER_TYPE_RESERVATION' && $setup.orderDetailData.order_state === 'ORDER_STATUS_WAITING') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(" 请前往"), _createElementVNode("strong", null, _toDisplayString($setup.startAddress), 1), _createTextVNode("上车，若您迟到或不在上车位置，将可能被取消订单。 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type !== 'ORDER_TYPE_VOICE' && $setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_PICK_UP' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(" 请尽快前往"), _createElementVNode("strong", null, _toDisplayString($setup.startAddress), 1), _createTextVNode("上车，若您迟到太久或不在上车位置，将可能被取消订单。 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type !== 'ORDER_TYPE_VOICE' && $setup.orderDetailData.order_state === 'ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createTextVNode(" 司机正在前往"), _createElementVNode("strong", null, _toDisplayString($setup.endAddress), 1), _createTextVNode("。安全出行，请您系好安全带，并照看好您的随身物品。 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_VOICE' && $setup.orderDetailData.order_state === 'ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createTextVNode(" 司机正在前往目的地，"), _hoisted_22, _createTextVNode("。安全出行，请您系好安全带，并照看好您的随身物品。 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' || $setup.orderDetailData.order_state === 'ORDER_STATUS_RATING') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [_createTextVNode(" 实际到达时间"), _createElementVNode("strong", null, _toDisplayString($setup.orderDetailData.arrive_destination_time), 1), _createTextVNode("，感谢使用" + _toDisplayString($options.Config.appName) + "。 ", 1)], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_RESERVATION' && $setup.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 5
  }, [_createTextVNode(" 请在"), _createElementVNode("strong", null, _toDisplayString($setup.orderDetailData.useCarTime), 1), _createTextVNode("之前到达"), _createElementVNode("strong", null, _toDisplayString($setup.startAddress), 1), _createTextVNode("上车，届时若您迟到或不在上车位置，将可能被取消订单。 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_VOICE' && $setup.orderDetailData.order_state !== 'ORDER_STATUS_PROGRESSING' && $setup.orderDetailData.order_state !== 'ORDER_STATUS_ARRIVED_DROP_OFF' && $setup.orderDetailData.order_state !== 'ORDER_STATUS_WAIT_PAYMENT' && $setup.orderDetailData.order_state !== 'ORDER_STATUS_RATING' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 6
  }, [_createTextVNode(" 当前订单为语音单，请"), _hoisted_23, _createTextVNode("。若您不在上车位置或无法与您取得联系，将可能被取消订单。 ")], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [$setup.orderDetailData && $setup.orderDetailData.functionType === 1 ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 0,
    size: "medium",
    type: "primary",
    plain: "",
    round: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "underway-o"
    }), _createTextVNode(" 打表来接 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.replacePassengerPhone && $setup.orderDetailData.replacePassengerPhone.length > 0 ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 1,
    size: "medium",
    type: "primary",
    plain: "",
    round: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "phone-o"
    }), _createTextVNode(" 代人叫车 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_VOICE' ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 2,
    size: "medium",
    type: "primary",
    plain: "",
    round: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "bullhorn-o"
    }), _createTextVNode(" 语音订单 ")]),
    _: 1
  })) : _createCommentVNode("", true)])])]), _createElementVNode("div", {
    class: "card-bold vehicle-info",
    style: _normalizeStyle($setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_VOICE' ? 'border-radius: 0 0 12px 12px;' : '')
  }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.plate_number : ''), 1), false ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.vehicle_brand : '') + " • " + _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.vehicle_color : ''), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString($setup.orderDetailData ? ((_$setup$orderDetailDa = $setup.orderDetailData.driver_name) === null || _$setup$orderDetailDa === void 0 ? void 0 : _$setup$orderDetailDa.substr(0, 1)) + '师傅' : ''), 1), $setup.orderDetailData && $setup.orderDetailData.driverQuality ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_van_icon, {
    name: "star"
  }), _createTextVNode(" " + _toDisplayString($setup.orderDetailData.driverQuality === 0 ? 5 : parseFloat($setup.orderDetailData.driverQuality).toFixed(1)) + "分 ", 1)])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_service_count ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString($setup.orderDetailData.order_service_count) + "单 ", 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_32, [$setup.orderDetailData && ((_$setup$orderDetailDa2 = $setup.orderDetailData.plate_number) === null || _$setup$orderDetailDa2 === void 0 ? void 0 : _$setup$orderDetailDa2.length) > 7 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: require('@/assets/img/vehicle/taxi-ne.png')
  }, null, 8, _hoisted_33)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: require('@/assets/img/vehicle/taxi.png')
  }, null, 8, _hoisted_34)), $setup.orderDetailData && $setup.orderDetailData.vehicle_transport_company_name ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.vehicle_transport_company_name : ''), 1)) : _createCommentVNode("", true)])], 4), $setup.orderDetailData && $setup.orderDetailData.order_type !== 'ORDER_TYPE_VOICE' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("div", _hoisted_39, _toDisplayString($setup.orderDetailData.departure_address), 1)]), _createVNode(_component_van_icon, {
    class: "line",
    name: "down"
  }), _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, _toDisplayString($setup.orderDetailData.destination_address), 1)])])) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' || $setup.orderDetailData.order_state === 'ORDER_STATUS_RATING') ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createVNode(_component_van_cell_group, {
    border: false
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: "上车时间"
    }, {
      value: _withCtx(() => [_createElementVNode("div", _hoisted_44, _toDisplayString($setup.orderDetailData.passenger_pick_up_time), 1)]),
      _: 1
    }), _createVNode(_component_van_cell, {
      title: "到达时间"
    }, {
      value: _withCtx(() => [_createElementVNode("div", _hoisted_45, _toDisplayString($setup.orderDetailData.arrive_destination_time), 1)]),
      _: 1
    }), $setup.orderDetailData.transportation_distance ? (_openBlock(), _createBlock(_component_van_cell, {
      key: 0,
      title: "实际里程"
    }, {
      value: _withCtx(() => [_createElementVNode("div", _hoisted_46, _toDisplayString($setup.orderDetailData.transportation_distance) + " 公里", 1)]),
      _: 1
    })) : _createCommentVNode("", true), $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createBlock(_component_van_cell, {
      key: 1,
      title: "行驶时长"
    }, {
      value: _withCtx(() => [_createElementVNode("div", _hoisted_47, _toDisplayString($options.CommonUtil.formatSeconds($options.CommonUtil.toDate($setup.orderDetailData.arrive_destination_time, 'YYYY-MM-DD HH:mm:ss').getTime() / 1000 - $options.CommonUtil.toDate($setup.orderDetailData.departure_destination_time, 'YYYY-MM-DD HH:mm:ss').getTime() / 1000)), 1)]),
      _: 1
    })) : _createCommentVNode("", true), $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createBlock(_component_van_cell, {
      key: 2,
      title: "行程费用"
    }, {
      value: _withCtx(() => [_createElementVNode("div", _hoisted_48, _toDisplayString($setup.orderDetailData.transportation_cost.toFixed(2)) + " 元", 1)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_49, [$setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAITING' || $setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_PICK_UP' || $setup.orderDetailData.order_state === 'ORDER_STATUS_PROGRESSING') ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "options-item",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.contactDriver && $options.contactDriver(...args))
  }, [_createVNode(_component_van_icon, {
    name: "phone-o"
  }), _createTextVNode("  联系司机 ")])) : _createCommentVNode("", true), false && $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT') ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_createVNode(_component_van_icon, {
    name: "service-o"
  }), _createTextVNode("  需要帮助 ")])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state !== 'ORDER_STATUS_RATING' ? (_openBlock(), _createElementBlock("div", _hoisted_51)) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_CONFIRMING' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAITING' || $setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_PICK_UP') ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "options-item",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.cancelOrder && $options.cancelOrder(...args))
  }, [_createVNode(_component_van_icon, {
    name: "revoke"
  }), _createTextVNode("  取消订单 ")])) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_PICK_UP1' || $setup.orderDetailData.order_state === 'ORDER_STATUS_PROGRESSING') ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createVNode(_component_van_icon, {
    name: "service-o"
  }), _createTextVNode("  需要帮助 ")])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createVNode(_component_van_loading, {
    size: "16px"
  }, {
    default: _withCtx(() => [_hoisted_54]),
    _: 1
  })])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createElementBlock("div", {
    key: 6,
    class: "options-item",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goCheckout && $options.goCheckout(...args))
  }, [_createVNode(_component_van_icon, {
    name: "gold-coin-o"
  }), _createTextVNode("  支付费用 ")])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_RATING' ? (_openBlock(), _createElementBlock("div", {
    key: 7,
    class: "options-item",
    onClick: _cache[5] || (_cache[5] = $event => $options.RouterUtil().back())
  }, [_createVNode(_component_van_icon, {
    name: "passed"
  }), _createTextVNode("  完成订单 ")])) : _createCommentVNode("", true)])])])), [[_directive_height_animate]])])]);
}